import { Box, Heading, Loading, Message, Text } from '@workwhile/ui'
import { useVndlyTimesheetContext } from '../../context/VndlyTimesheetProvider'
import { TimesheetIssuesTable } from './TimesheetIssuesTable'

export function TimesheetIssues() {
  const {
    state: {
      issuesState: {
        requiresWorkWhileAdminIntervention,
        workOrderAssociationIssues,
        queryState: { isEnabled, isLoading, isError, isFetched },
      },
    },
  } = useVndlyTimesheetContext()

  const hasWorkOrderAssociationIssues = workOrderAssociationIssues.length > 0

  return (
    <Box mb={4}>
      <Heading level={3} mb={2}>
        Issues
      </Heading>
      <Text color="lightText" mb={3}>
        Review work order mapping issues before downloading the timesheet.
      </Text>
      {!isEnabled ? (
        <Message variant="info">
          Select at least one company and a valid date range to view issues.
        </Message>
      ) : null}
      {isEnabled && isLoading ? <Loading /> : null}
      {isEnabled && isError ? (
        <Message variant="error">
          Something went wrong loading timesheet issues. Please try again or
          contact WorkWhile support if the issue persists.
        </Message>
      ) : null}
      {isEnabled && isFetched && requiresWorkWhileAdminIntervention ? (
        <Message variant="warning" mb={3}>
          Some timesheet issues require WorkWhile support to resolve. Please
          contact WorkWhile support before downloading.
        </Message>
      ) : null}
      {isEnabled &&
      isFetched &&
      !requiresWorkWhileAdminIntervention &&
      !hasWorkOrderAssociationIssues &&
      !isLoading ? (
        <Message variant="success">
          No work order issues found for the selected filters.
        </Message>
      ) : null}
      {isEnabled && isFetched && hasWorkOrderAssociationIssues ? (
        <TimesheetIssuesTable />
      ) : null}
    </Box>
  )
}
